import React, { useEffect } from 'react'
import { Container } from 'react-grid-system'

import { useTranslation } from 'react-i18next'
import { useAgGridUltra } from '../../components/AgGrid/AgGridUltra/hooks/useAgGridUltra'
import { useSyncListGrid } from './gridConfigHooks/useSyncListGrid'
import DataUpload from './DataUpload'

const InventoryDataUploadContainer = (props) => {
  const { vIds, loading = true } = props
  const { t } = useTranslation()

  const generateComponent = (componentProps) => {
    return (
      <DataUpload vIds={componentProps.vIds} loading={componentProps.loading} />
    )
  }

  const grids = [
    {
      id: 'sync-list',
      label: t('UPLOADS'),
      useGetParams: useSyncListGrid(),
    },
    {
      id: 'sync-data-upload',
      label: t('DATA UPLOAD'),
      component: generateComponent,
    },
  ]

  const { generateGrid, generatePills, setComponentProps } = useAgGridUltra(
    'Operations',
    grids
  )
  useEffect(() => {
    setComponentProps({ vIds, loading })
  }, [loading, setComponentProps, vIds])

  return (
    <Container fluid>
      {generatePills()}
      {generateGrid()}
    </Container>
  )
}

export default InventoryDataUploadContainer
